module.exports = __webpack_public_path__ + "img/bp-logo-dark.4c5dda8e.svg";